export default "__VITE_ASSET__B2m7vxZD__"